import {Injectable, ViewContainerRef} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import {Questions} from "../../classes/question";
import {Age} from "../../classes/age";
import {Anomalies} from "../../classes/anomaly";

@Injectable()
export class BroadcastAnomaliesService {



  private anomalies : Anomalies[];

  private subject: Subject<Anomalies[]> = new Subject<Anomalies[]>();

  setAnomalies(anomalies: Anomalies[]): void {
    this.anomalies = anomalies;
    this.subject.next(anomalies);
  }

  getAnomalies(): Observable<Anomalies[]> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/broadcast-anomalies.service.ts